import { useTranslation } from "react-i18next";
import Helmet from "react-helmet";
import ImageHeader from "../../../../components/image-header/image-header";
import liveAnimalsImg from "../../../../assets/imgs/services/nationals/live-animals.jpg";
import Accordion from "../../../../components/acordion/accordion";
import { useEffect, useState } from "react";
import axios from "axios";
import navBarEn from "../../../../translations/en/navbar.json";
import navBarEs from "../../../../translations/es/navbar.json";

function LiveAnimals() {
  const [tLiveAnimals] = useTranslation("liveAnimalsPage");
  const [tSMetaData] = useTranslation("metaData");
  const idLiveAnimals = "4c7bc6a5-2883-403f-9cf4-b1312507e7f3";
  const [textDescription, setTextDescription] = useState("");
  const [accordion2, setAccordion2] = useState("");

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].services}/${
      Object.keys(navBarEs["products-submenu"])[0]
    }/${Object.keys(navBarEs["products-nacionales-submenu"])[6]}`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].services}/${
      Object.keys(navBarEn["products-submenu"])[0]
    }/${Object.keys(navBarEn["products-nationals-submenu"])[6]}`
  );

  useEffect(() => {
    let currentLng = "";
    localStorage.getItem("lng")
      ? (currentLng = `${localStorage.getItem("lng")}`)
      : (currentLng = "es");

    axios
      .get(
        `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idLiveAnimals}`,
        {
          headers: {
            Authorization: process.env.REACT_APP_PUBLIC_KEY,
          },
        }
      )
      .then((response) => {
        if (currentLng === "es") {
          setTextDescription(
            response.data.textWeb.text_es["01-descripción"].content
          );
          setAccordion2(
            response.data.textWeb.text_es[
              "03-Documentación, Aceptación y Recolección"
            ].content
          );
        } else {
          setTextDescription(
            response.data.textWeb.text_us["01-description"].content
          );
          setAccordion2(
            response.data.textWeb.text_us["03-Check-in, Acceptance and Pickup"]
              .content
          );
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <>
      <Helmet>
        <title>{tSMetaData("animalesVivos.title")}</title>
        <meta
          name="description"
          content={tSMetaData("animalesVivos.description")}
        />
      </Helmet>
      <ImageHeader
        section={tLiveAnimals("header.section")}
        title={tLiveAnimals("header.title")}
        description={
          textDescription
            ? JSON.parse(textDescription)
            : JSON.parse(tLiveAnimals("description.content"))
        }
        quoteBtn={tLiveAnimals("header.quote-btn")}
        quoteProductID="btnQuoteAnimals"
        contactSales={tLiveAnimals("header.contact-sales")}
        contactProductID="btnContactAnimals"
        imgBackground={liveAnimalsImg}
      />
      <Accordion
        title={tLiveAnimals("accordion-1.title")}
        content={JSON.parse(tLiveAnimals("accordion-1.content"))}
      />
      <div className="divider"></div>
      <Accordion
        title={tLiveAnimals("accordion-2.title")}
        content={
          accordion2
            ? JSON.parse(accordion2)
            : JSON.parse(tLiveAnimals("accordion-2.content"))
        }
      />
      <div className="divider"></div>
      <Accordion
        title={tLiveAnimals("accordion-3.title")}
        content={JSON.parse(tLiveAnimals("accordion-3.content"))}
      />
      <div className="divider"></div>
    </>
  );
}

export default LiveAnimals;
